export default __webpack_public_path__ + "static/banner3-0c28ec530a93a3a8e3c69e9e3648e83d.jpg";